import { atom } from "jotai";

import { appAtom } from "./app";

export const toggleSidebarAtom = atom(
  (get) => get(appAtom).sidebarOpen,
  (_get, set) => {
    set(appAtom, (prev) => ({
      ...prev,
      sidebarOpen: !prev.sidebarOpen,
    }));
  },
);
